<template>
  <div id="app">
    <MonitoreoView />
  </div>
</template>

<script>
import MonitoreoView from './components/MonitoreoView.vue';

export default {
  name: 'App',
  components: {
    MonitoreoView
  }
};
</script>
